import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import {
    closeSnackbar as closeSnackbarAction,
    removeSnackbar as removeSnackbarAction
} from './redux/uiSlices';
const mapStateToProps = (state: RootState) => ({
    snackbars: Object.values(state.ui.snackbars)
});

let displayed = [] as string[];

type Props = ReturnType<typeof mapStateToProps>;

const Snackbars = ({ snackbars }: Props) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const storeDisplayed = (id: string) => {
        displayed = [...displayed, id];
    };

    const removeDisplayed = (id: string) => {
        displayed = [...displayed.filter(key => id !== key)];
    };

    // Using notistack library instead of material ui because material ui
    // can only show one snackbar at a time, while notistack can show multiple.
    useEffect(() => {
        snackbars.forEach(({ id, message, autoHideDuration, isOpen, position, severity, persist }) => {
            if (!isOpen) {
                // dismiss snackbar using notistack
                closeSnackbar(id);
                return;
            }

            // do nothing if snackbar is already displayed
            if (displayed.includes(id)) {
                return;
            }

            // display snackbar using notistack
            enqueueSnackbar(message, {
                key: id,
                autoHideDuration: autoHideDuration ?? undefined,
                anchorOrigin: position ?? { vertical: 'top', horizontal: 'right' },
                variant: severity,
                persist: persist,
                action: () => (
                    <IconButton
                        onClick={() => dispatch(closeSnackbarAction(id))}
                        color="primary"
                        sx={{ color: 'white' }}
                    >
                        <CloseIcon />
                    </IconButton>
                ),
                onClose: () => {
                    dispatch(closeSnackbarAction(id));
                },
                onExited: () => {
                    // remove this snackbar from redux store
                    dispatch(removeSnackbarAction(id));
                    removeDisplayed(id);
                }
            });

            // keep track of snackbars that we've displayed
            storeDisplayed(id);
        });
    }, [snackbars, closeSnackbar, enqueueSnackbar, dispatch]);

    return null;
};
export default connect(mapStateToProps)(Snackbars);
